import "../styles/notifications.css";
import { useEffect } from "react";
import { useNotifications } from "../notifications/NotificationsContext";

export default function NotificationsPage() {
  const { notifications, markAsRead, loading, error, refresh } = useNotifications();

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <main className="notifications-page">
      <h1 className="notifications-title">Notificaciones</h1>

      {loading && <p className="notifications-empty">Cargando notificaciones...</p>}
      {error && (
        <p className="notifications-empty" style={{ color: "#b71c1c", fontWeight: 600 }}>
          {error}
        </p>
      )}

      <section className="notifications-list">
        {!loading && !notifications.length && (
          <p className="notifications-empty">No tienes notificaciones nuevas.</p>
        )}

        {notifications.map((notification) => (
          <article
            key={notification.id}
            className={`notification-card ${notification.read ? "read" : ""}`}
          >
            <div className="notification-content">
              <h3>{notification.title}</h3>
              <span className="notification-date">{notification.date}</span>
              <p>{notification.description}</p>
            </div>

            <button
              className="mark-read-btn"
              onClick={() => markAsRead(notification.id)}
              disabled={notification.read}
            >
              {notification.read ? "Leído" : "Marcar como leído"}
            </button>
          </article>
        ))}
      </section>
    </main>
  );
}
